






























































































import Vue from "vue";

import types from "@/store/types";

import SectionArea from "@/components-stateful/section-area.vue";
import SvgLogo from "@/components/SvgLogo.vue";
import Icon from "@/components/icon.vue";
import ie from "../../utils/ie11";

export default Vue.extend({
  name: "stores-top",
  components: {
    SectionArea,
    SvgLogo,
    Icon,
  },
  data() {
    return {
      isAvailable: false,
    };
  },
  computed: {
    placeName(): string {
      return this.$store.state.store !== undefined ? this.$store.state.store.name : "";
    },
    isMarui(): boolean {
      return this.$route.params["storeName"] === "marui-yurakucho";
    },
    isOsakaTerminal(): boolean {
      return this.$route.params["storeName"] === "grandfront-osaka";
    },
    isShibuyaTsutaya(): boolean {
      return this.$route.params["storeName"] === "shibuya-tsutaya";
    },
    isSapporoParco(): boolean {
      return this.$route.params["storeName"] === "sapporo-parco";
    },
    isTetsudoKaikan(): boolean {
      return this.$route.params["storeName"] === "tetsudokaikan";
    },
    isContrated(): boolean {
      if (
        this.$store.state.storeContract !== undefined &&
        (this.$store.state.storeContract.useStatus === "installation" ||
          this.$store.state.storeContract.useStatus === "going")
      ) {
        return true;
      }
      this.isAvailable = true;
      return false;
    },
    isIE11(): boolean {
      return ie.isIE11();
    },
    statusMessage(): string {
      const currentDate: number = new Date().getTime();
      const finishedDateOfIE: number = new Date("2022-05-01T00:00:00").getTime();
      if (currentDate < finishedDateOfIE) {
        return "いたします";
      } else {
        return "しております";
      }
    },
  },
  methods: {
    openUrl(url: string): void {
      window.open(url);
    },
  },
  async mounted() {
    const storeName: string = this.$route.params["storeName"];
    if (storeName === "marui-yurakucho") {
      window.location.href = "https://throne.vacanservice.com/aa38d7bcad184d";
    }
    const success: boolean = await this.$store.dispatch(types.actions.SETUP, storeName);
    if (!success) {
      this.$router.push({ path: "/" });
      return;
    }
    this.$store.dispatch(types.actions.LOOP);
  },
});
